import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Button, Stack } from '@mui/material';
import { FC } from 'react';
import { Development, LegalPerson } from '~/api/types';
import { DevelopmentSelectionButton } from '~/components/magic-link-wizard/button/development-selection-button';
import { Page } from '~/components/ui/page';
import { Body1, Title } from '~/components/ui/typography';
import config from '~/config';

export const DevelopmentSelectionScreen: FC<DevelopmentSelectionScreenProps> = ({
  person,
  onDevelopmentSelection,
  goBack,
}) => {
  const CURRENT_CUB_MAGIC_LINK = window.location.host;
  const IS_WHITE_LABEL = config.CUB_HOST !== CURRENT_CUB_MAGIC_LINK;

  const filteredDevelopments = person.developments
    .filter((d) => {
      // always show all contracts for non-white-label deployments
      if (!IS_WHITE_LABEL) return true;

      // show only contracts allowed of current magic link white-label
      const sanitizedMagicLinkUrl = d.magicLinkUrl?.replace('https://', '').replace('/', '');
      if (sanitizedMagicLinkUrl === CURRENT_CUB_MAGIC_LINK) return true;

      return false;
    })
    .sort((a, b) => a.companyName.localeCompare(b.companyName));

  const message =
    filteredDevelopments.length > 1
      ? 'Identificamos mais de um vínculo em seu cadastro. Selecione uma opção abaixo para continuar:'
      : 'Selecione uma opção abaixo para continuar:';

  if (filteredDevelopments.length === 0)
    return (
      <Page>
        <Title>Nenhum empreendimento encontrado</Title>
        <Box width={'444px'}>
          <Body1>Verifique os dados informados ou entre em contato com o atendimento</Body1>
        </Box>
        <Stack gap={2} mt={3} alignItems={'center'}>
          <Button startIcon={<ChevronLeftIcon />} onClick={goBack} sx={{ fontWeight: 'bold' }}>
            Voltar
          </Button>
        </Stack>
      </Page>
    );

  return (
    <Page>
      <Title>O que deseja acessar?</Title>
      <Box width={'444px'}>
        <Body1>{message}</Body1>
      </Box>
      <Box>
        {filteredDevelopments.map((development, idx) => {
          return (
            <DevelopmentSelectionButton
              key={idx}
              development={development}
              onClickWhenUrlIsNull={() => onDevelopmentSelection(development)}
            />
          );
        })}
      </Box>
      <Stack gap={2} mt={3} alignItems={'center'}>
        <Button startIcon={<ChevronLeftIcon />} onClick={goBack} sx={{ fontWeight: 'bold' }}>
          Voltar
        </Button>
      </Stack>
    </Page>
  );
};

interface DevelopmentSelectionScreenProps {
  person: LegalPerson;
  onDevelopmentSelection: (customer: Development) => void;
  goBack: () => void;
}
